import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface MaintenanceState {
  enabled: boolean;
  message: string;
}

export const useMaintenanceMode = () => {
  const { user } = useAuth();
  const [state, setState] = useState<MaintenanceState>({ enabled: false, message: "" });
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const load = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("content")
        .eq("id", "maintenance")
        .maybeSingle();
      if (!active) return;
      const c = (data?.content as any) || {};
      setState({ enabled: !!c.enabled, message: c.message || "" });
      setLoading(false);
    };
    load();

    const channel = supabase
      .channel(`site_settings_maintenance_${Math.random().toString(36).slice(2)}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "site_settings", filter: "id=eq.maintenance" },
        () => load()
      )
      .subscribe();

    return () => {
      active = false;
      supabase.removeChannel(channel);
    };
  }, []);

  useEffect(() => {
    if (!user) {
      setIsAdmin(false);
      return;
    }
    supabase
      .from("user_roles")
      .select("role")
      .eq("user_id", user.id)
      .eq("role", "admin")
      .maybeSingle()
      .then(({ data }) => setIsAdmin(!!data));
  }, [user]);

  return { ...state, isAdmin, loading };
};
